// extracted by mini-css-extract-plugin
export default {"container":"OthersMessageItem_container__ksgQm","messageContent":"OthersMessageItem_messageContent__WqpF3"};